(function MediaHubSearchFilter($, Adzuki)
{
	const component = {
		emits: ['filtered-media', 'visibility-changed'],
		props: {
			media: {
				type   : Array,
				default: () => []
			},
			sectionInfo: {
				type: Object,
			},
			// hide files whose sections aren't listed (images/docs paths) when a section is set;
			// the redesigned picker turns it off, its Library | Attachments split does that job
			hideUnlistedSections: {
				type   : Boolean,
				default: true,
			}
		},
		template: '#mediahub-search-filters',
		data() {
			return {
				keywordSearch    : '',
				fileTypes        : [],
				contentTypes     : [],
				showFavorites    : false,
				showGlobalFiles  : false,
				showFranchise    : false,
				showUntagged     : false,
				exInputValue     : '',
				exSuggestions    : [],
				showExSuggestions: false,
				selectedExTags   : [],
				inInputValue     : '',
				inSuggestions    : [],
				showInSuggestions: false,
				selectedInTags   : [],
				bsCollapse       : null,
				filterOpen       : false,
				imageFileTypes   : [
					'jpg',
					'png',
					'tiff',
					'gif',
					'bmp',
					'webp'
				],
				videoFileTypes: [
					'mp4',
					'webm',
					'mov'
				],
				docFileTypes: [
					'pdf',
					'doc',
					'xls',
					'ppt',
					'csv',
					'txt',
					'rtf',
					'eml',
					'msg'
				],
				extensionAliases: {
					jpg: [
						'jpg',
						'jpeg'
					],
					tiff: [
						'tiff',
						'tif'
					],
					doc: [
						'doc',
						'docx'
					],
					xls: [
						'xls',
						'xlsx',
					],
					ppt: [
						'ppt',
						'pptx'
					]
				},
				statusOptions: [
					{
						id  : 'restricted',
						name: 'Approved - Limited'
					},
					{
						id  : 'pending',
						name: 'Pending Unlimited Approval'
					},
					{
						id  : 'approved',
						name: 'Approved - Unlimited'
					}
				],
				filterByTag        : {},
				mediaSections      : [],
				mediaSectionsLoaded: false,
				showSections       : [],
				showStatuses       : []
			};
		},
		computed: {
			visibilitySwitches() {
				return {
					showGlobalFiles: this.showGlobalFiles,
					showFranchise  : this.showFranchise,
				};
			},
			filteredMedia() {
				const mediaArray = this.media;

				const agentId = (this.$agentId) ? String(this.$agentId) : null;

				const result =  mediaArray.filter((media) => {
					const tags     = Array.isArray(media.media_tags) ? media.media_tags : [];
					const versions = Array.isArray(media.versions) ? media.versions : [];
					const ext       = (media.extension || '').toString().toLowerCase();


					const keywordMatches = !this.keywordSearch || [
							media.title,
							media.description,
							media.original_file_name,
							media.actual_file_name,
							media.path,
							media.remote_url,
							media.agent_name,
							media.section_name
						].some(field => field && field.toString().toLowerCase().includes(this.keywordSearch.toLowerCase())) ||
						(tags.some(tag =>
							tag
							&& tag.name
							&& tag.name.toString().toLowerCase().includes(this.keywordSearch.toLowerCase())
						));

					const includeTagsMatches = this.selectedInTags.length ? tags.some(mediaTag => this.selectedInTags.some(selectedTag => selectedTag.id === mediaTag.id)) : true;

					const excludeTagsMatches = this.selectedExTags.length ? !tags.some(mediaTag => this.selectedExTags.some(selectedTag => selectedTag.id === mediaTag.id)) : true;

					const globalMatches      = this.showGlobalFiles ? true : media.global === '0';

					const franchiseMatches = (
						media.agent_id === agentId ||
						(this.showFranchise && media.share_franchise === '1') ||
						(this.showGlobalFiles && media.global === '1')
					);

					const favoriteMatches = this.showFavorites
						? media.favorite === '1'
						: true;

					const unTaggedMatches    = this.showUntagged ? tags.length === 0 : true;

					const listedSectionIds = this.sectionOptions.map(section => String(section.id));
					const matchesSectionIds = (sectionIds) => {
						return sectionIds.includes(String(media.media_section_id)) ||
							versions.some(version => sectionIds.includes(String(version.media_section_id)));
					};

					let sectionMatches = true;

					if (this.showSections.length) {
						sectionMatches = matchesSectionIds(this.showSections);
					} else if (this.sectionInfo && this.mediaSectionsLoaded && this.hideUnlistedSections) {
						const associatedSectionIds = [];

						if (media.media_section_id) {
							associatedSectionIds.push(String(media.media_section_id));
						}

						versions.forEach((version) => {
							if (version.media_section_id) {
								associatedSectionIds.push(String(version.media_section_id));
							}
						});

						const uniqueAssociatedSectionIds = [...new Set(associatedSectionIds)];

						if (
							uniqueAssociatedSectionIds.length > 0
							&& !uniqueAssociatedSectionIds.some(sectionId => listedSectionIds.includes(sectionId))
						) {
							sectionMatches = false;
						}
					}

					const statusMatches      = this.showStatuses.length ? this.showStatuses.includes(media.status) && media.type === 'image' : true;

					const contentTypeMatches = this.contentTypes.length
						? this.contentTypes.includes(media.type)
						: true;

					// every extension of a type selected (the type button, a tag count link) means
					// the whole type, so files whose extension isn't in the list still show (MEDIA-311)
					const typeExtensions = this[`${media.type}FileTypes`] || [];
					const wholeType      = this.contentTypes.includes(media.type)
						&& typeExtensions.length > 0
						&& typeExtensions.every(type => this.fileTypes.includes(type));

					const extensionMatches = this.fileTypes.length && !wholeType
						? this.fileTypes.some(type => {
							if (this.extensionAliases[type]) {
								return this.extensionAliases[type].includes(ext);
							}
							return type === ext;
						})
						: true;

					const typeMatches = contentTypeMatches && extensionMatches;


					return keywordMatches && includeTagsMatches && excludeTagsMatches && typeMatches && favoriteMatches && globalMatches && unTaggedMatches && franchiseMatches && sectionMatches && statusMatches;
				});

				return [...result];
			},
			sectionOptions() {
				if (Array.isArray(this.mediaSections)) {
					return this.mediaSections
						.filter(section => {
							const path = (section.section_path || '').toString().toLowerCase();
							if (this.sectionInfo) {
								return path.startsWith('images') || path.startsWith('docs');
							}
							return true;
						})
						.map(section => ({
							id  : section.id,
							name: section.name
						}));
				}
				return [];
			}
		},
		methods: {
			resetFilters() {
				this.keywordSearch   = '';
				this.selectedInTags  = [];
				this.selectedExTags  = [];
				this.contentTypes    = [];
				this.showFavorites   = false;
				this.showFranchise   = false;
				this.showUntagged    = false;
				this.fileTypes       = [];
				this.showSections    = [];
				this.$refs.sectionMultiselect.reset();
				// image status too: switches in Manage Media and the picker, a multiselect in the
				// older picker form (MEDIA-298)
				this.showStatuses    = [];

				if (this.$refs.statusMultiselect) {
					this.$refs.statusMultiselect.reset();
				}

				if (this.$franchiseId !== '1') {
					this.showGlobalFiles = false;
				}
			},
			async searchTags(index, value, input) {
				if (!value || value.length === 0) {
					if (input === 'in') {
						this.inSuggestions = [];
						this.showInSuggestions = false;
					} else {
						this.exSuggestions = [];
						this.showExSuggestions = false;
					}
					return;
				}

				try {
					const formData = new FormData();
					formData.append('term', value);

					// Make a POST request to the backend
					const response = await fetch(this.$baseUri + '/MediaTag/searchTags', {
						method: 'POST',
						body  : formData,
					});

					if (!response.ok) {
						throw new Error(`Error while fetching categories: ${response.statusText}`);
					}

					const data = await response.json();

					if (data) {
						if (input === 'in') {
							this.inSuggestions = data;
							this.showInSuggestions = true;
						} else {
							this.exSuggestions = data;
							this.showExSuggestions = true;
						}
					} else {
						console.error('Unexpected data format from server:', data);
						if (input === 'in') {
							this.inSuggestions = [];
						} else {
							this.exSuggestions = [];
						}
					}
				} catch (err) {
					console.error('Error in searchTags:', err.message);
					if (input === 'in') {
						this.inSuggestions = [];
					} else {
						this.exSuggestions = [];
					}
				}
			},
			selectTag(fileIndex, tag, input) {
				if (input === 'in') {
					const exIndex = this.selectedExTags.findIndex(t => t.id === tag.id);

					if (exIndex !== -1) {
						this.selectedExTags.splice(exIndex, 1);
					}

					if (!this.selectedInTags.some(t => t.id === tag.id)) {
						this.selectedInTags.push(tag);
					}

					this.showInSuggestions = false;
					this.inSuggestions     = [];
					this.inInputValue      = '';


				} else {
					const inIndex = this.selectedInTags.findIndex(t => t.id === tag.id);

					if (inIndex !== -1) {
						this.selectedInTags.splice(inIndex, 1);
					}

					if (!this.selectedExTags.some(t => t.id === tag.id)) {
						this.selectedExTags.push(tag);
					}

					this.showExSuggestions = false;
					this.exSuggestions     = [];
					this.exInputValue      = '';
				}
			},
			removeTag(fileIndex, tagIndex, input) {
				if (input === 'in') {
					this.selectedInTags.splice(tagIndex, 1);
				} else {
					this.selectedExTags.splice(tagIndex, 1);
				}
			},
			filterByType(type) {
				const originalData = this.$options.data();
				const index     = this.contentTypes.findIndex(t => t === type);

				if (index === -1) {
					this.contentTypes.push(type);
				} else {
					this.contentTypes.splice(index, 1);
				}

				this.$nextTick(() => {
					if (this.contentTypes.includes(type)) {
						this.fileTypes = [...originalData[`${type}FileTypes`]];
					} else {
						this.fileTypes = this.fileTypes.filter(fileType =>
							!originalData[`${type}FileTypes`].includes(fileType)
						);
					}
				});
			},
			filterByFile(file) {
				let index = this.fileTypes.findIndex(t => t === file);

				if (index === -1) {
					this.fileTypes.push(file);
				} else {
					this.fileTypes.splice(index, 1);
				}
				this.checkContentType();
			},
			checkContentType() {
				// Check for image files
				if (!this.fileTypes.some(type => this.imageFileTypes.includes(type))) {
					const imageIndex = this.contentTypes.indexOf('image');
					if (imageIndex !== -1) {
						this.contentTypes.splice(imageIndex, 1);
					}
				} else if (this.imageFileTypes.every(type => this.fileTypes.includes(type))) {
					if (!this.contentTypes.includes('image')) {
						this.contentTypes.push('image');
					}
				}

				// Check for video files
				if (!this.fileTypes.some(type => this.videoFileTypes.includes(type))) {
					const videoIndex = this.contentTypes.indexOf('video');
					if (videoIndex !== -1) {
						this.contentTypes.splice(videoIndex, 1);
					}
				} else if (this.videoFileTypes.every(type => this.fileTypes.includes(type))) {
					if (!this.contentTypes.includes('video')) {
						this.contentTypes.push('video');
					}
				}

				// Check for doc files
				if (!this.fileTypes.some(type => this.docFileTypes.includes(type))) {
					const docIndex = this.contentTypes.indexOf('doc');
					if (docIndex !== -1) {
						this.contentTypes.splice(docIndex, 1);
					}
				} else if (this.docFileTypes.every(type => this.fileTypes.includes(type))) {
					if (!this.contentTypes.includes('doc')) {
						this.contentTypes.push('doc');
					}
				}
			},
			getSections() {
				const url = `${this.$baseUri}/MediaSection/getSections`;

				fetch(url)
					.then(response => {
						if (!response.ok) {
							throw new Error(`Error Fetching Media Sections: ${response.statusText}`);
						}
						return response.json();
					})
					.then(data => {
						this.mediaSections = data || [];
					})
					.catch(error => {
						console.error('Error fetching Media Sections:', error);
						this.mediaSections = [];
					})
					.finally(() => {
						this.mediaSectionsLoaded = true;
					});
				return null;
			},
			handleMultiSelect(data) {
				if (data.identifier === 'section') {
					this.showSections = (data.selected || []).map(String);
				} else if (data.identifier === 'status') {
					this.showStatuses = data.selected;
				}
			},
			// a Media Tags count link: that tag and file type, with the Include switches its
			// count needs (reveal, MEDIA-311); Media Tags has already picked the tab
			applyFilterByTag(tagInfo) {
				if (!tagInfo || Object.keys(tagInfo).length === 0) {
					return;
				}

				const reveal = tagInfo.reveal || null;
				const type   = Object.keys(tagInfo).filter(key => key !== 'reveal')[0];
				const defaults = this.$options.data();

				if (!type || !defaults[`${type}FileTypes`]) {
					return;
				}

				this.selectedInTags = [tagInfo[type]];
				this.fileTypes      = [...defaults[`${type}FileTypes`]];
				this.contentTypes   = [type];

				if (reveal) {
					this.showFranchise   = this.showFranchise || Boolean(reveal.shared);
					this.showGlobalFiles = this.showGlobalFiles || Boolean(reveal.global);
				} else if (tagInfo[type].global === '1') {
					this.showGlobalFiles = true;
				}

				sessionStorage.removeItem('filterByTag');
			},
			toggleFilterCollapse() {
				if (this.bsCollapse) {
					this.bsCollapse.toggle();
				}
			}
		},
		watch: {
			// the Include Global / Include Shared switches, for Manage Media's tab counts
			visibilitySwitches: {
				handler(value) {
					this.$emit('visibility-changed', value);
				},
				immediate: true,
			},
			filteredMedia: {
				handler() {
					// when MediaHub finishes fetching and updates the prop, emit filtered result
					this.$emit('filtered-media', this.filteredMedia);
				},
				immediate: true
			}
		},
		created() {
			let sessionData = sessionStorage.getItem('filterByTag');
			if (sessionData) {
				this.filterByTag = JSON.parse(sessionData);
				this.applyFilterByTag(this.filterByTag);
			}

		},
		mounted() {
			this.getSections();

			if (this.$franchiseId === '1') {
				this.showGlobalFiles = true;
			}

			if (this.$refs.filterCollapseContainer) {
				const collapseElement = this.$refs.filterCollapseContainer;

				this.bsCollapse = new bootstrap.Collapse(collapseElement, {
					toggle: false,
				});

				collapseElement.addEventListener('shown.bs.collapse', () => {
					this.filterOpen = true;
				});

				collapseElement.addEventListener('hidden.bs.collapse', () => {
					this.filterOpen = false;
				});
			}
		}
	};

	Adzuki.VueComponents.MediaHubSearchFilter = component;
}(jQuery, window.Adzuki || {}));
